var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.s.row},_vm._l((_vm.elementsArray),function(element,index){return _c('span',{key:element,class:[_vm.s.text, { [_vm.s.active]: index === _vm.activeIndex }],on:{"click":function($event){return _vm.onChange(index)}}},[_vm._v(" "+_vm._s(element)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }